module.exports = __webpack_public_path__ + "ae8088e9ea6226c6456f767a5fac1149.svg";